import React from 'react';

const TextArea = ({ name, label, rows, defaultValue, error, ...rest }) => {
  return (
    <div className="form-group">
      <label
        style={{
          display: 'block',
          color: 'black',
          fontWeight: 'bold',
          fontSize: 12 + 'px'
        }}
        htmlFor={name}
      >
        {label}
      </label>
      <textarea
        {...rest}
        name={name}
        id={name}
        rows={rows}
        //defaultValue={defaultValue}
        className="form-control"
      />
      {error && <div className="alert alert-danger">{error}</div>}
    </div>
  );
};

export default TextArea;
